// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ySElE","title":"Info_title__2Tm0M","links":"Info_links__3DnQv","link":"Info_link__16GRH","logo":"Info_logo__YNY9Q"};